import FuzzySearch from "fuzzy-search";
import {
  GetListParams,
  MaterialRepositoryInterface,
  UpdateListParams,
  UpdateListResult,
} from "./material.repository.d";
import { BaseRepository } from "../Base/base.repository";
import { GetMaterialDto } from "./dto/get.dto";
import { ServerlessConfigure } from "../../config/serverless-configure";
import { UpdateMaterialDto } from "./dto/update.dto";

export class MaterialRepository
  extends BaseRepository<GetMaterialDto>
  implements MaterialRepositoryInterface
{
  constructor() {
    super(
      {
        baseURL: `${ServerlessConfigure.ApiEndpoint}`,
      },
      {
        hasSendToken: true,
      },
    );
  }

  async getList(params: GetListParams): Promise<GetMaterialDto[]> {
    const { tenantId } = params;
    const response = await this.apiRequest.getList({
      url: `/materials?tenantId=${tenantId}`,
    });

    const searcher = new FuzzySearch(
      response.data.Items,
      [
        "name",
        "materialKey",
        "materialCategories",
        "materialUnitPrice",
        "materialManufacturer",
        "materialRooms",
        "materialSurfaces",
        "materialInstanceFileName",
        "homeNames",
        "tenantName",
      ],
      {
        caseSensitive: false,
      },
    );
    const result = searcher.search(params.keyword);
    return result;
  }

  async update(params: UpdateMaterialDto) {
    const response = await this.apiRequest.put<GetMaterialDto>({
      url: `/materials/${params.materialKey}`,
      data: {
        name: params.name ?? undefined,
        materialCategory: params.materialCategory ?? undefined,
        materialCategories: params.materialCategories ?? undefined,
        materialUnitPrice: params.materialUnitPrice ?? undefined,
        isActive: params.isActive ?? undefined,
        userId: params.userId,
      },
    });

    return response;
  }

  async updateList(params: UpdateListParams) {
    const response = await this.apiRequest.put<UpdateListResult>({
      url: `/materials`,
      data: {
        userId: params.userId,
        items: params.items,
      },
    });

    return response;
  }
}
